export default "__VITE_ASSET__C51K1upH__"